import { HttpMessageReader } from './types.ts';
import { MediaType } from '../media-type.ts';
import { isCompatibleWith } from '../../utils/mime-type-utils.ts';
import type { HttpInputMessage } from '../../../types/web/http';
import { LoggingCodecSupport } from './core.ts';

export class MultipartHttpMessageReader extends LoggingCodecSupport implements HttpMessageReader<FormData> {
    static readonly MEDIA_TYPES = Object.freeze([MediaType.MULTIPART_FORM_DATA]);
    #partReader: HttpMessageReader<[string, FormDataEntryValue]>;

    constructor(partReader: HttpMessageReader<[string, FormDataEntryValue]>) {
        super();
        this.#partReader = partReader;
    }

    get partReader() {
        return this.#partReader;
    }

    getReadableMediaTypes(): ReadonlyArray<MediaType> {
        return MultipartHttpMessageReader.MEDIA_TYPES;
    }


    canRead(type, mediaType?: MediaType): boolean {
        return this.#supportsMediaType(mediaType) && (type.name === FormData.name);
    }

    #supportsMediaType(mediaType?: MediaType): boolean {
        if (mediaType === undefined) return true;

        for (const supportedMediaType of MultipartHttpMessageReader.MEDIA_TYPES) {
            if (isCompatibleWith(supportedMediaType, mediaType)) {
                return true;
            }
        }
        return false;
    }

    async readPromise(type, message: HttpInputMessage, hints: Map<string, unknown>): Promise<FormData> {
        const stream = this.#partReader.read(type, message, hints);
        const result = new FormData();
        for await (const  [name, value] of stream) {
            result.append(name, value)
        }
        return result;
    }


    read(type, message: HttpInputMessage, hints: Map<string, unknown>): ReadableStream<FormData> {
        throw new Error(`not implemented yet`);
    }

}


export class DefaultPartHttpMessageReader extends LoggingCodecSupport implements HttpMessageReader<[string, FormDataEntryValue]> {
    getReadableMediaTypes(): ReadonlyArray<MediaType> {
        return [MediaType.MULTIPART_FORM_DATA];
    }

    canRead(type, mediaType?: MediaType): boolean {
        return type === 'string' || type.name === File.name && (
            mediaType === undefined || isCompatibleWith(MediaType.MULTIPART_FORM_DATA, mediaType)
        );
    }

    readPromise(type, message: HttpInputMessage, hints: Map<string, unknown>): Promise<[string, FormDataEntryValue]> {
        throw new Error(`not implemented yet`);
    }

    read(type, message: HttpInputMessage, hints: Map<string, unknown>): ReadableStream<[string, FormDataEntryValue]> {
        throw new Error(`not implemented yet`);
    }
}
